import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppointmentFormPreferences {
  actionsExpanded: boolean;
  detailsExpanded: boolean;
}

const initialState: AppointmentFormPreferences = {
  actionsExpanded: true,
  detailsExpanded: true,
};

export const normalizeAppointmentFormPreferences = (value: unknown): AppointmentFormPreferences => {
  const preferences = value && typeof value === "object" ? value as Partial<AppointmentFormPreferences> : {};
  return {
    actionsExpanded: typeof preferences.actionsExpanded === "boolean" ? preferences.actionsExpanded : true,
    detailsExpanded: typeof preferences.detailsExpanded === "boolean" ? preferences.detailsExpanded : true,
  };
};

const appointmentFormPreferencesSlice = createSlice({
  name: "appointmentFormPreferences",
  initialState,
  reducers: {
    setAppointmentFormPanelExpanded: (
      state,
      { payload }: PayloadAction<{ panel: keyof AppointmentFormPreferences; expanded: boolean }>,
    ) => {
      state[payload.panel] = payload.expanded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createAction("clear"), () => initialState);
  },
});

export const { setAppointmentFormPanelExpanded } = appointmentFormPreferencesSlice.actions;
export default appointmentFormPreferencesSlice.reducer;
